import { render, staticRenderFns } from "./PricingTariffsFeaturesSliders.vue?vue&type=template&id=f7095444"
import script from "./PricingTariffsFeaturesSliders.vue?vue&type=script&lang=js"
export * from "./PricingTariffsFeaturesSliders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports